import { render, staticRenderFns } from "./TransformerDetails.vue?vue&type=template&id=5671975b&"
import script from "./TransformerDetails.vue?vue&type=script&lang=js&"
export * from "./TransformerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports